"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCoreComponent = getCoreComponent;
exports.isFunctionalComponent = isFunctionalComponent;
exports.attachWrappedComponent = attachWrappedComponent;
exports.copyMethods = copyMethods;
exports.makeDecoratorRefCallback = void 0;

function getCoreComponent(Component) {
  var node = Component;

  while (node.WrappedComponent) {
    node = node.WrappedComponent;
  }

  return node;
}

function isFunctionalComponent(Component) {
  return !Component.prototype || !Component.prototype.render;
}

function attachWrappedComponent(Decorator, WrappedComponent) {
  Decorator.WrappedComponent = WrappedComponent;
  Decorator.CoreComponent = getCoreComponent(WrappedComponent);
}

function copyMethods(wrappedInstance, decoratorInstance) {
  // Copy all methods from the wrapped component instance to this wrapper,
  // so that this wrapper is usable as a ref.
  if (!wrappedInstance) {
    return;
  }

  Object.getOwnPropertyNames(wrappedInstance).filter(function (key) {
    return key !== 'getDOMNode';
  }) // See #4515
  .forEach(function (key) {
    if (typeof wrappedInstance[key] === 'function' && !decoratorInstance[key]) {
      decoratorInstance[key] = wrappedInstance[key];
    }
  });
}

var makeDecoratorRefCallback = function makeDecoratorRefCallback(Component, decoratorInstance) {
  if (isFunctionalComponent(Component)) return undefined;
  return function (ref) {
    copyMethods(ref, decoratorInstance);
  };
};

exports.makeDecoratorRefCallback = makeDecoratorRefCallback;